import React from 'react';
import './wecompanyname.scss'
import sciquspartner from '../../assest/sciquspartner.png'
import retainmanagegrow from '../../assest/retainmanagegrow.png'

const WeCompanyName = () => {
	return (
		<>
			<div id="revora" className="mainWeCompanyName">
				<div className="WeCompanyNameTitle">
					<h2>We <strong>The Revora</strong></h2>
				</div>
				<div className="subWeCompanyName">
					<div className="WeCompanyName">
						<div className="WeCompanyNameimage">
							<img src={sciquspartner} alt=""/>
						</div>
						<div className="WeCompanyNameparag">
							<p>We are an authorized Sciqus Consulting Partner, deeply experienced in the Sciqus AMS ecosystem. With strong domain expertise and hands-on implementation knowledge, we represent Sciqus AMS on the ground and ensure customers achieve real business value.</p>
						</div>
						<div className="WeCompanyNameimage2">
							<img src={retainmanagegrow} alt=""/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default WeCompanyName;